import { ITEM } from '@utils/constants';
import { TargetFormat } from './format-date.type';

export function formatDate(dateString: Date, targetFormat: TargetFormat) {
  // Create a Date object from the date string
  const date = new Date(dateString);
  const PADDING_LENGTH = 2;
  // Get date components
  const day = String(date.getDate()).padStart(PADDING_LENGTH, '0');
  const month = String(date.getMonth() + ITEM.SINGLE_EMISSION).padStart(PADDING_LENGTH, '0');
  const year = date.getFullYear();

  // Combine components based on target format
  switch (targetFormat) {
    case 'dd-MM-yyyy':
      return `${day}-${month}-${year}`;
    case 'yyyy-MM-dd':
      return `${year}-${month}-${day}`;
    case 'dd MMMM yyyy':
      return `${day} ${date.toLocaleString('en-US', { month: 'long' })} ${year}`;
    default:
      return 'Invalid format';
  };
};